export const ATTACHMENT_POLICY = {
    NONE: "NONE",
    OPTIONAL: "OPTIONAL",
    MANDATORY_AT_WAITING_LIST: "MANDATORY_AT_WAITING_LIST",
    MANDATORY_BEFORE_ACTIVATION: "MANDATORY_BEFORE_ACTIVATION",
};

// Absent for non-SALES_ORDER PMCs, which never carry a policy; callers fall back to the deprecated booleans.
export const attachmentPolicyOf = (product) => product?.AttachmentPolicy ?? null;

export const policyEnablesAttachments = (policy) =>
    !!policy && policy !== ATTACHMENT_POLICY.NONE;

export const policyRequiresBeforeActivation = (policy) =>
    policy === ATTACHMENT_POLICY.MANDATORY_AT_WAITING_LIST ||
    policy === ATTACHMENT_POLICY.MANDATORY_BEFORE_ACTIVATION;

export const policyRequiresAtWaitingList = (policy) =>
    policy === ATTACHMENT_POLICY.MANDATORY_AT_WAITING_LIST;
